import React, { useCallback, useEffect, useState } from "react";
import Proptypes from "prop-types";
// import OrderPaymentImg from "assets/images/order-payment.png";
import "./index.scss";

const Order = ({ items, price }) => {
  const [orderItems, setOrderItems] = useState(null);

  const getSortedOrderItems = useCallback(() => {
    const zoningOrders = [];
    const stackOrders = [];
    const orders = [];
    items.forEach((item) => {
      if (item.item_type === "zoning") {
        zoningOrders.push({
          type: item.item_type,
          data: {
            details: item.details,
            id: item.id,
            farm: item.farm,
            price: item.price,
          },
        });
      }
      if (item.item_type === "stack analysis order") {
        stackOrders.push({
          type: item.item_type,
          data: {
            details: item.details,
            id: item.id,
            farm: item.farm,
            price: item.price,
          },
        });
      }
    });
    orders.push({ zoning: zoningOrders, stack: stackOrders });
    setOrderItems(orders);
  }, [items]);

  useEffect(() => {
    if (!items) return;
    if (items) {
      getSortedOrderItems();
    }
  }, [items, getSortedOrderItems]);

  return (
    <div className="payment-order">
      {orderItems && orderItems[0]?.zoning?.length > 0 && (
        <>
          <div className="type">VRT Zoning</div>
          {orderItems[0]?.zoning.map((item) => (
            <>
              <div className="order-details" href="/">
                <div className="item-name">
                  {item?.data?.farm.properties?.farm_name}
                </div>
                <div className="item-details">
                  <div className="details">
                    {item?.data?.details?.num_zones} zones
                  </div>
                  ·
                  <div className="details">
                    {item?.data?.details?.fields.length} fields
                  </div>
                  <div className="price">
                    AU{" "}
                    {(item?.data?.price).toLocaleString("en-US", {
                      style: "currency",
                      currency: "USD",
                    })}
                  </div>
                </div>
              </div>
            </>
          ))}
        </>
      )}
      {orderItems && orderItems[0]?.stack?.length > 0 && (
        <>
          <div className="type">Stack</div>
          {orderItems[0]?.stack.map((item) => (
            <>
              <div className="order-details" href="/">
                <div className="item-name">
                  {item?.data?.farm.properties?.farm_name}
                </div>
                <div className="item-details">
                  {/* <div className="details">
                    {item?.data?.details?.num_zones} zones
                  </div>
                  · */}
                  <div className="details">
                    {item?.data?.details?.fields.length} fields
                  </div>
                  <div className="price">
                    AU{" "}
                    {(item?.data?.price).toLocaleString("en-US", {
                      style: "currency",
                      currency: "USD",
                    })}
                  </div>
                </div>
              </div>
            </>
          ))}
        </>
      )}
      <div className="separator" />
      <div className="price">
        <div className="total">
          AU{" "}
          {parseFloat(price).toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          })}
        </div>
        <div className="label">Total Price</div>
      </div>
    </div>
  );
};

Order.defaultProps = {
  price: "",
  items: {},
};

Order.propTypes = {
  price: Proptypes.string,
  items: Proptypes.object,
};

export default Order;
